var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBufferloop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1840 267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3448 -2110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buffer_loop"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1932,
    cy: 1827,
    r: 69,
    fill: "rgb(245,245,245)",
    transform: "matrix(1 0 0 1 1977.808 436)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1932,
    cy: 1827,
    r: 69,
    fill: "rgb(245,245,245)",
    transform: "matrix(1 0 0 1 2266.133 436)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1932,
    cy: 1827,
    r: 69,
    fill: "rgb(245,245,245)",
    transform: "matrix(1 0 0 1 2554.465 436)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1932,
    cy: 1827,
    r: 69,
    fill: "rgb(250,222,42)",
    transform: "matrix(1 0 0 1 2842.79 436)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14796.5 16105.6v-240.3",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "32.92px",
    transform: "matrix(-.01862 -.0212 .04815 -.04229 4371.274 3163.415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14863.5 16997.2l-37.7-1931.8",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "121.42px",
    transform: "matrix(-.01338 .00107 -.00107 -.01338 5042.905 2354.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16194.5 18450.1l-1395-4733.1",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "121.42px",
    transform: "matrix(-.01034 -.00856 .00856 -.01034 4880.882 2440.732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14863.5 16997.2l-64-3280.2",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "121.42px",
    transform: "matrix(-.00378 -.01288 .01288 -.00378 4750.492 2434.393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.011-.547v-.16h.286V0h-.18v-.547H.011z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(69.99978 0 0 70.00015 3897.727 2290.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.497-.129H.232L.188 0h-.18l.259-.702h.197L.723 0H.541L.497-.129zm-.044-.13l-.088-.26-.089.26h.177z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3868.64 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.413-.564c.064 0 .115.021.153.064a.26.26 0 01.056.176V0H.451v-.304a.128.128 0 00-.029-.088.103.103 0 00-.079-.031.105.105 0 00-.082.033C.24-.368.23-.337.23-.296V0H.059v-.558H.23v.102a.183.183 0 01.072-.079.208.208 0 01.111-.029z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3883.24 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.271-.565c.043 0 .079.01.11.029a.174.174 0 01.068.079v-.101h.17V0h-.17v-.101a.174.174 0 01-.068.079.205.205 0 01-.11.029.224.224 0 01-.209-.134.344.344 0 01-.032-.152c0-.059.011-.11.032-.153a.223.223 0 01.209-.133zm.055.15a.113.113 0 00-.088.036c-.023.024-.034.057-.034.1 0 .043.011.076.034.1a.113.113 0 00.088.036.116.116 0 00.089-.037.14.14 0 00.034-.099.141.141 0 00-.034-.1.118.118 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3896.76 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    d: "M.059-.74H.23V0H.059z",
    transform: "matrix(19.99983 0 0 20.0001 3910.32 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.188-.558l.134.342.125-.342h.189L.288.266H.1l.131-.287-.234-.537h.191z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3916.1 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.21-.143h.258V0H.023v-.135l.24-.281H.027v-.142h.431v.135l-.248.28z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3928.78 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.589-.294a.268.268 0 01-.005.046H.197c.002.042.013.072.032.09a.1.1 0 00.074.028.1.1 0 00.063-.019.087.087 0 00.033-.049H.58a.23.23 0 01-.048.105.252.252 0 01-.094.073.292.292 0 01-.127.027.296.296 0 01-.145-.035.239.239 0 01-.1-.099.308.308 0 01-.036-.152.31.31 0 01.036-.153.248.248 0 01.099-.099.303.303 0 01.146-.034.3.3 0 01.146.034.249.249 0 01.098.095.287.287 0 01.034.142zM.416-.32C.417-.357.407-.384.387-.403A.112.112 0 00.311-.43a.112.112 0 00-.078.028C.212-.383.201-.356.198-.32h.218z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 3938.58 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23-.248V0H.059v-.707h.277c.084 0 .148.021.192.062a.222.222 0 01.066.169c0 .044-.01.083-.029.117a.198.198 0 01-.088.081.306.306 0 01-.141.03H.23zm.087-.137c.069 0 .103-.03.103-.091 0-.062-.034-.093-.103-.093H.23v.184h.087z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4162.302 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.614-.558V0H.442v-.101a.185.185 0 01-.071.078.214.214 0 01-.111.029.19.19 0 01-.152-.064.255.255 0 01-.057-.176v-.324h.17v.303c0 .038.01.067.03.088a.102.102 0 00.079.032.105.105 0 00.082-.033c.02-.022.03-.053.03-.094v-.296h.172z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4174.682 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.407-.565c.046 0 .087.011.124.034a.252.252 0 01.086.099.345.345 0 01.031.153c0 .058-.01.109-.031.152a.23.23 0 01-.32.105.167.167 0 01-.067-.079V0H.059v-.74H.23v.283a.167.167 0 01.067-.079.205.205 0 01.11-.029zm-.055.15a.115.115 0 00-.088.036.142.142 0 00-.035.1.14.14 0 00.035.099.112.112 0 00.088.037.117.117 0 00.089-.036.142.142 0 00.033-.1.142.142 0 00-.033-.1.117.117 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4188.142 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    d: "M.059-.74H.23V0H.059z",
    transform: "matrix(20 0 0 20.0001 4201.702 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.043-.715c0-.026.009-.048.028-.065a.105.105 0 01.074-.025c.031 0 .055.008.074.025a.083.083 0 01.028.065.08.08 0 01-.028.063.102.102 0 01-.074.026.102.102 0 01-.074-.026.08.08 0 01-.028-.063zm.187.157V0H.059v-.558H.23z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4207.482 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.262-.565a.26.26 0 01.17.053.232.232 0 01.079.14h-.16A.092.092 0 00.32-.426a.097.097 0 00-.062-.019.07.07 0 00-.044.012.046.046 0 00-.015.036c0 .017.009.03.028.039a.431.431 0 00.086.026c.043.01.078.02.105.03a.187.187 0 01.071.051.14.14 0 01.03.094c0 .032-.009.06-.026.085a.165.165 0 01-.075.058.293.293 0 01-.116.021.301.301 0 01-.181-.05.211.211 0 01-.083-.143h.165a.075.075 0 00.031.055.11.11 0 00.068.019.064.064 0 00.044-.014.044.044 0 00.015-.035c0-.019-.009-.033-.027-.042a.553.553 0 00-.09-.026.792.792 0 01-.102-.028.16.16 0 01-.069-.049.134.134 0 01-.029-.091.15.15 0 01.057-.122.249.249 0 01.161-.046z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4213.262 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.413-.564c.064 0 .115.021.153.064a.26.26 0 01.056.176V0H.451v-.304a.128.128 0 00-.029-.088.103.103 0 00-.079-.031.105.105 0 00-.082.033C.24-.368.23-.337.23-.296V0H.059v-.74H.23v.284a.183.183 0 01.072-.079.208.208 0 01.111-.029z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4224.362 2370.801)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.23-.571v.148h.239v.129H.23v.157h.269V0h-.44v-.707h.44v.136H.23z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4447.79 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.413-.564c.064 0 .115.021.153.064a.26.26 0 01.056.176V0H.451v-.304a.128.128 0 00-.029-.088.103.103 0 00-.079-.031.105.105 0 00-.082.033C.24-.368.23-.337.23-.296V0H.059v-.558H.23v.102a.183.183 0 01.072-.079.208.208 0 01.111-.029z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4458.53 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.271-.565c.043 0 .079.01.11.029a.174.174 0 01.068.079v-.101h.17v.555c0 .052-.01.099-.03.141a.237.237 0 01-.092.099.293.293 0 01-.154.037.318.318 0 01-.201-.059.242.242 0 01-.091-.162H.22c.005.023.018.04.037.053a.127.127 0 00.074.019c.035 0 .064-.01.086-.03C.438.074.449.042.449-.003v-.098a.174.174 0 01-.068.079.205.205 0 01-.11.029.224.224 0 01-.209-.134.344.344 0 01-.032-.152c0-.059.011-.11.032-.153a.223.223 0 01.209-.133zm.055.15a.113.113 0 00-.088.036c-.023.024-.034.057-.034.1 0 .043.011.076.034.1a.113.113 0 00.088.036.116.116 0 00.089-.037.14.14 0 00.034-.099.141.141 0 00-.034-.1.118.118 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4472.05 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.271-.565c.043 0 .079.01.11.029a.174.174 0 01.068.079v-.101h.17V0h-.17v-.101a.174.174 0 01-.068.079.205.205 0 01-.11.029.224.224 0 01-.209-.134.344.344 0 01-.032-.152c0-.059.011-.11.032-.153a.223.223 0 01.209-.133zm.055.15a.113.113 0 00-.088.036c-.023.024-.034.057-.034.1 0 .043.011.076.034.1a.113.113 0 00.088.036.116.116 0 00.089-.037.14.14 0 00.034-.099.141.141 0 00-.034-.1.118.118 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4485.61 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.271-.565c.043 0 .079.01.11.029a.174.174 0 01.068.079v-.101h.17v.555c0 .052-.01.099-.03.141a.237.237 0 01-.092.099.293.293 0 01-.154.037.318.318 0 01-.201-.059.242.242 0 01-.091-.162H.22c.005.023.018.04.037.053a.127.127 0 00.074.019c.035 0 .064-.01.086-.03C.438.074.449.042.449-.003v-.098a.174.174 0 01-.068.079.205.205 0 01-.11.029.224.224 0 01-.209-.134.344.344 0 01-.032-.152c0-.059.011-.11.032-.153a.223.223 0 01.209-.133zm.055.15a.113.113 0 00-.088.036c-.023.024-.034.057-.034.1 0 .043.011.076.034.1a.113.113 0 00.088.036.116.116 0 00.089-.037.14.14 0 00.034-.099.141.141 0 00-.034-.1.118.118 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4499.17 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.589-.294a.268.268 0 01-.005.046H.197c.002.042.013.072.032.09a.1.1 0 00.074.028.1.1 0 00.063-.019.087.087 0 00.033-.049H.58a.23.23 0 01-.048.105.252.252 0 01-.094.073.292.292 0 01-.127.027.296.296 0 01-.145-.035.239.239 0 01-.1-.099.308.308 0 01-.036-.152.31.31 0 01.036-.153.248.248 0 01.099-.099.303.303 0 01.146-.034.3.3 0 01.146.034.249.249 0 01.098.095.287.287 0 01.034.142zM.416-.32C.417-.357.407-.384.387-.403A.112.112 0 00.311-.43a.112.112 0 00-.078.028C.212-.383.201-.356.198-.32h.218z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(19.99983 0 0 20.0001 4512.73 2370.801)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.382-.714a.35.35 0 01.224.071.32.32 0 01.114.192H.539a.167.167 0 00-.061-.077.172.172 0 00-.099-.028.15.15 0 00-.121.055.221.221 0 00-.046.147c0 .061.015.11.046.146a.15.15 0 00.121.055.172.172 0 00.099-.028.17.17 0 00.061-.076H.72a.321.321 0 01-.338.263.346.346 0 01-.181-.046.3.3 0 01-.12-.127.394.394 0 01-.043-.187c0-.07.014-.132.043-.187a.309.309 0 01.12-.128.355.355 0 01.181-.045z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4724.42 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.589-.294a.268.268 0 01-.005.046H.197c.002.042.013.072.032.09a.1.1 0 00.074.028.1.1 0 00.063-.019.087.087 0 00.033-.049H.58a.23.23 0 01-.048.105.252.252 0 01-.094.073.292.292 0 01-.127.027.296.296 0 01-.145-.035.239.239 0 01-.1-.099.308.308 0 01-.036-.152.31.31 0 01.036-.153.248.248 0 01.099-.099.303.303 0 01.146-.034.3.3 0 01.146.034.249.249 0 01.098.095.287.287 0 01.034.142zM.416-.32C.417-.357.407-.384.387-.403A.112.112 0 00.311-.43a.112.112 0 00-.078.028C.212-.383.201-.356.198-.32h.218z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4739.56 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    d: "M.059-.74H.23V0H.059z",
    transform: "matrix(20 0 0 20.0001 4751.94 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.589-.294a.268.268 0 01-.005.046H.197c.002.042.013.072.032.09a.1.1 0 00.074.028.1.1 0 00.063-.019.087.087 0 00.033-.049H.58a.23.23 0 01-.048.105.252.252 0 01-.094.073.292.292 0 01-.127.027.296.296 0 01-.145-.035.239.239 0 01-.1-.099.308.308 0 01-.036-.152.31.31 0 01.036-.153.248.248 0 01.099-.099.303.303 0 01.146-.034.3.3 0 01.146.034.249.249 0 01.098.095.287.287 0 01.034.142zM.416-.32C.417-.357.407-.384.387-.403A.112.112 0 00.311-.43a.112.112 0 00-.078.028C.212-.383.201-.356.198-.32h.218z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4757.72 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.407-.565c.046 0 .087.011.124.034a.252.252 0 01.086.099.345.345 0 01.031.153c0 .058-.01.109-.031.152a.23.23 0 01-.32.105.167.167 0 01-.067-.079V0H.059v-.74H.23v.283a.167.167 0 01.067-.079.205.205 0 01.11-.029zm-.055.15a.115.115 0 00-.088.036.142.142 0 00-.035.1.14.14 0 00.035.099.112.112 0 00.088.037.117.117 0 00.089-.036.142.142 0 00.033-.1.142.142 0 00-.033-.1.117.117 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4770.1 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23-.453a.238.238 0 01.083-.081c.033-.02.07-.03.109-.03v.183H.373a.17.17 0 00-.105.029C.243-.333.23-.3.23-.254V0H.059v-.558H.23v.105z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4783.66 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.271-.565c.043 0 .079.01.11.029a.174.174 0 01.068.079v-.101h.17V0h-.17v-.101a.174.174 0 01-.068.079.205.205 0 01-.11.029.224.224 0 01-.209-.134.344.344 0 01-.032-.152c0-.059.011-.11.032-.153a.223.223 0 01.209-.133zm.055.15a.113.113 0 00-.088.036c-.023.024-.034.057-.034.1 0 .043.011.076.034.1a.113.113 0 00.088.036.116.116 0 00.089-.037.14.14 0 00.034-.099.141.141 0 00-.034-.1.118.118 0 00-.089-.036z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4792.36 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.375-.147V0H.298a.217.217 0 01-.152-.049C.109-.081.091-.134.091-.209v-.205H.016v-.144h.075v-.137h.171v.137h.112v.144H.262v.208c0 .022.005.037.014.046.008.009.024.013.045.013h.054z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4805.92 2370.801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.589-.294a.268.268 0 01-.005.046H.197c.002.042.013.072.032.09a.1.1 0 00.074.028.1.1 0 00.063-.019.087.087 0 00.033-.049H.58a.23.23 0 01-.048.105.252.252 0 01-.094.073.292.292 0 01-.127.027.296.296 0 01-.145-.035.239.239 0 01-.1-.099.308.308 0 01-.036-.152.31.31 0 01.036-.153.248.248 0 01.099-.099.303.303 0 01.146-.034.3.3 0 01.146.034.249.249 0 01.098.095.287.287 0 01.034.142zM.416-.32C.417-.357.407-.384.387-.403A.112.112 0 00.311-.43a.112.112 0 00-.078.028C.212-.383.201-.356.198-.32h.218z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(20 0 0 20.0001 4814.16 2370.801)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.034-.136c.212-.151.318-.272.318-.361 0-.055-.024-.082-.071-.082-.027 0-.046.009-.058.028a.163.163 0 00-.021.087H.035c.004-.086.03-.151.078-.194a.263.263 0 01.182-.065c.077 0 .135.019.174.058a.207.207 0 01.058.151.315.315 0 01-.079.201.737.737 0 01-.189.167h.279v.138H.034v-.128z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(69.99978 0 0 70.00015 4179.193 2290.6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.302-.738c.049 0 .092.009.127.025a.199.199 0 01.081.07c.018.03.027.064.027.101a.17.17 0 01-.035.111.156.156 0 01-.089.053v.005c.091.029.137.086.137.171a.202.202 0 01-.028.108.188.188 0 01-.081.074.286.286 0 01-.129.027.29.29 0 01-.193-.06C.071-.093.045-.154.041-.236h.167c.001.031.01.056.026.074.016.018.039.027.07.027a.078.078 0 00.059-.022.08.08 0 00.021-.057c0-.058-.042-.087-.126-.087H.226V-.44h.031C.332-.439.37-.466.37-.521c0-.024-.006-.043-.019-.056a.072.072 0 00-.053-.019.072.072 0 00-.057.024.114.114 0 00-.024.066H.05a.237.237 0 01.07-.172.258.258 0 01.182-.06z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(69.99978 0 0 70.00015 4466.146 2290.6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.044-.13v-.143l.323-.443h.184v.437h.085v.149H.551V0H.378v-.13H.044zm.348-.388l-.174.239h.174v-.239z",
    fill: "rgb(35,31,32)",
    fillRule: "nonzero",
    transform: "matrix(69.99978 0 0 70.00015 4748.97 2290.6)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2125.68 1659.73s51.21-35.9 117.04 4.14",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "1.5px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1 0 0 1 1889.465 526.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.02 1789.95c15.72-1.28 63.04-6.29 76.02 7.02 10.1 10.36-14.98 32.43-63.4 49.09",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "7.32px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.13368 .13783 -.15584 .15115 4166.834 1664.375)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1791.82 1794.11c15.72-1.28 51.37-10.52 56.83 6.07 4.34 13.18-27.51 31.66-45.32 38.46",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "4.84px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.24211 -.1604 .18136 .27375 3622.23 2121.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410.18 1814.2c17.24 21.64 75.94 44.8 109.82-5",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "1.5px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1 0 0 1 1876.297 508.22)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1791.82 1794.11c15.72-1.28 51.37-10.52 56.83 6.07 4.34 13.18-27.51 31.66-45.32 38.46",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "4.84px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.16784 .23701 -.26798 .18977 4870.08 1425.166)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2696.49 1684.91s67.48-45.49 129.48 2.09",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "1.5px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1 0 0 1 1871.817 517.319)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1584 1691s117.83 233.25 355.83 103.25",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "1.5px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1 0 0 1 1866.307 491.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796 1793c15.72-1.28 41.5-5.73 46.04 3.97 3.11 6.65-11.28 22.03-34.86 36.23",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "4.23px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.24712 .25385 -.25385 .24712 3611.578 1406.174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796 1793c15.72-1.28 41.5-5.73 46.04 3.97 3.11 6.65-11.28 22.03-34.86 36.23",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "4.23px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.35362 -.02153 .02153 .35362 3115.865 1689.825)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2987.12 1805.76c34.22 12.65 95.15 26.96 170.13 9.15 64.53-15.33 139.47-54.45 216.75-138.91",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "1.5px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(1 0 0 1 1912.296 507)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1791.82 1794.11c15.72-1.28 51.37-10.52 56.83 6.07 4.34 13.18-27.51 31.66-45.32 38.46",
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "4.84px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2,
    transform: "matrix(.28272 .06643 -.0751 .31967 4682.119 1623.95)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.40837 0 0 .40838 3669.422 1525.776)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2982,
    cy: 1734,
    r: 12,
    fill: "none",
    stroke: "rgb(35,31,32)",
    strokeWidth: "3.67px",
    strokeLinejoin: "miter",
    strokeMiterlimit: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBufferloop);
export default __webpack_public_path__ + "static/media/bufferloop.2d4f19e4f1be909f8aee9590213cb201.svg";
export { ForwardRef as ReactComponent };